import PriceQuotesPageTable from './PriceQuotesPageTable';

export default PriceQuotesPageTable;
